export const env = 'pearl';
const url = {
      pearl: "https://backendprod.cansell.in"
}

export const API_URL = `${url[env]}`;
